import { jwtDecode } from "jwt-decode";

export enum RolesEnum {
  ADMIN = "ADMIN",
  ASSIGNOR = "ASSIGNOR",
  Doutorado = "Doutorado",
  RESELLER = "RESELLER",
  PSYCHOLOGIST = "PSYCHOLOGIST",
}

export enum TokenPermissions {
  Seduc = "Seduc",
  Parceiros = "Parceiros",
}

export interface AccessTokenData {
  uid: string;
  roles: string[]; //if null has no one role
  permissions?: TokenPermissions[]; // If null token has all permissions
  crp?: string | null;
}

export const getUserRolesFromToken = (): string[] => {
  const token = localStorage.getItem("AccessToken");
  if (!token) return [];
  try {
    const decoded = jwtDecode<AccessTokenData>(token);
    return decoded.roles || [];
  } catch (error) {
    console.error("Failed to decode token or get roles:", error);
    return [];
  }
};

export const getUserPermissionsFromToken = (): TokenPermissions[] => {
  const token = localStorage.getItem("AccessToken");
  if (!token) return [];
  try {
    const decoded = jwtDecode<AccessTokenData>(token);
    return decoded.permissions || [];
  } catch (error) {
    console.error("Failed to decode token or get permissions:", error);
    return [];
  }
};

export const getUserCrp = (): string | null => {
  const token = localStorage.getItem("AccessToken");
  if (!token) return null;
  try {
    const decoded = jwtDecode<AccessTokenData>(token);
    return decoded.crp || null;
  } catch (error) {
    console.error("Failed to decode token or get CRP:", error);
    return null;
  }
};
